import { Dialog, DialogContent, DialogTitle, DialogHeader } from "@/components/ui/dialog";
import { Separator } from "@/components/ui/separator";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import imageUrl from "@/assets/images/no-img.png";

export default function ViewSpendGetItemOfferModal({ isOpen, onClose, offer }) {
  if (!offer) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[700px] bg-cblack4 text-cwhite border-neutral-800">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold text-cwhite">
            Offer Details
          </DialogTitle>
        </DialogHeader>
        <Separator className="bg-neutral-800 my-2" />

        <div className="flex flex-col gap-6 py-2">
          {/* Header Info */}
          <div className="flex justify-between items-start">
            <div>
              <h2 className="text-lg font-bold text-cyellow">{offer.name}</h2>
              <p className="text-sm text-gray-400 mt-1">{offer.description || "No description provided."}</p>
            </div>
            <Badge
              variant={offer.status === "active" ? "success" : "destructive"}
              className={
                offer.status === "active"
                  ? "bg-emerald-500/20 text-emerald-400 border border-emerald-500/30"
                  : "bg-red-500/20 text-red-400 border border-red-500/30"
              }
            >
              {offer.status ? offer.status.toUpperCase() : "INACTIVE"}
            </Badge>
          </div>

          <Separator className="bg-neutral-800" />

          {/* Spend Threshold Condition */}
          <div>
            <h3 className="font-semibold text-cwhite mb-2 flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-blue-500 inline-block"></span>
              Spend Condition
            </h3>
            <p className="text-sm text-gray-300">
              Customer must spend <span className="font-bold text-cyellow">£{offer.spend_threshold}</span> or more to qualify.
            </p>
          </div>

          {/* Get Free Items Section */}
          <div>
            <h3 className="font-semibold text-cwhite mb-3 flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-emerald-500 inline-block"></span>
              Get Items (Free Reward Items)
            </h3>
            {offer.get_items && offer.get_items.length > 0 ? (
              <div className="border border-neutral-800 rounded-lg overflow-hidden">
                <Table>
                  <TableHeader className="bg-cblack3">
                    <TableRow className="border-neutral-800">
                      <TableHead className="text-gray-300">Item Name</TableHead>
                      <TableHead className="text-gray-300">Type</TableHead>
                      <TableHead className="text-gray-300">Variant</TableHead>
                      <TableHead className="text-gray-300 text-center">Quantity</TableHead>
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {offer.get_items.map((item, idx) => (
                      <TableRow key={idx} className="border-neutral-800">
                        <TableCell className="font-medium text-cwhite flex items-center gap-3">
                          <img
                            src={
                              item.menu_item?.file_manager_url || imageUrl
                            }
                            alt={item.menu_item?.name || "Item"}
                            className="w-10 h-10 object-cover rounded border border-neutral-700"
                          />
                          <span>{item.menu_item?.name || item.display_name || "N/A"}</span>
                        </TableCell>
                        <TableCell className="capitalize text-gray-300">
                          {item.item_type?.replace(/_/g, " ") || "N/A"}
                        </TableCell>
                        <TableCell className="text-gray-300">
                          {item.variant?.name || "Standard"}
                        </TableCell>
                        <TableCell className="text-gray-300 text-center font-semibold">
                          {item.quantity || 1}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </div>
            ) : (
              <p className="text-sm text-gray-500 italic">No get items specified.</p>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
